import { util as fabricNativeUtils, Point as FabricPoint } from 'fabric';

import { Coords, MediaLine } from 'editor/src/store/design/types';

import CustomFabricRect from 'editor/src/fabric/CustomFabricRect';

import { getLineCapOffset } from './utils';

const fabricPropsToLineElementData = (
  px2mm: (size: number) => number,
  pageCoords: Coords,
  rect: CustomFabricRect,
  rounded: boolean,
): Partial<MediaLine> => {
  const { left = 0, top = 0, width = 0, angle = 0, height = 0 } = rect;
  const endPoint = fabricNativeUtils.rotatePoint(
    new FabricPoint(left + width, top),
    new FabricPoint(left, top),
    fabricNativeUtils.degreesToRadians(angle),
  );
  const lineCapOffset = getLineCapOffset(rounded, height, angle);
  return {
    x1: px2mm(left - pageCoords.left + lineCapOffset.x),
    y1: px2mm(top - pageCoords.top + lineCapOffset.y),
    x2: px2mm(endPoint.x - pageCoords.left - lineCapOffset.x),
    y2: px2mm(endPoint.y - pageCoords.top - lineCapOffset.y),
  };
};

export default fabricPropsToLineElementData;
